<template>
<div class="filter-wrap-container">
    <ul class="filter-ul" v-for="(item, index) in config" :key="index">
      <span class="title-wrap" @click="_getFilterGroup(item, $event)">
        <span>{{getTitle(item)}}</span>
        <div class="right-icon-wrap">
          <AToolTips v-if="item.open" :item="item" v-on="$listeners"></AToolTips>
          <a-icon class="arrow" :class="{arrowActive: item.open}" type="caret-down" />
        </div>
      </span>
      <CheckBoxGroup v-if="item.open" ref="checkBox" :instance="item" :groupType="item.componentGroup" v-on="$listeners"> </CheckBoxGroup>
    </ul>
  </div>
</template>

<script>
import AToolTips from '../common/AtoolTips.vue'
import CheckBoxGroup from '../common/checkBoxGroup'
import mixinFilterOperation from './mixins/index'

export default {
  mixins: [mixinFilterOperation],
  props: {
    config: Array,
    sideCode: Object, // 企业名录选中的参数
    searchParams: Object // 检索参数
  },
  data() {
    return {
    }
  },
  components: {
    CheckBoxGroup,
    AToolTips
  },
  watch: {
    // searchParams: {
    //   handler(nVal) {
    //     console.log(nVal)
    //   },
    //   deep: true
    // }
  },
  methods: {
  }
}
</script>
